import React from 'react'
import { RichTextView } from './RichTextView'

interface CompetencyViewCardProps {
  title: string
  description: string
  completed: number
  total: number
}

const CompetencyViewCard = ({
  title,
  description,
  completed,
  total,
}: CompetencyViewCardProps) => {
  const progress = total > 0 ? Math.round((completed / total) * 100) : 0
  const safeProgress = Math.min(100, Math.max(0, progress))

  return (
    <div className="card gw-competency-area-view-card">
      <div className="card-body gw-competency-area-view-body">
        <h3 className="gw-competency-area-view-title">{title}</h3>
       <RichTextView html={description} className="gw-competency-area-view-description" />
        <div className="gw-competency-area-view-progress">
          <div className="gw-competency-area-view-progress-text">
            <span className="gw-competency-area-view-progress-label">Progress:</span>
            <span className="gw-competency-area-view-progress-value">
              {completed} of {total}
            </span>
          </div>
          <div className="gw-competency-area-view-progress-bar">
            <div
              className="gw-competency-area-view-progress-bar-fill"
              style={{ width: `${safeProgress}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CompetencyViewCard
